module.exports = __webpack_public_path__ + "static/media/logo.cc9ee6ea.png";